import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import AnimatedTextInput from "../../components/animatedTextInput";
import ForgotPwd from "../../img/forgot_pwd.svg";
import CommonService from "./forgetPasswordAPI";
import createPersistedState from "use-persisted-state";
import { getIC4ID, parsePID } from "../../utils";

const useTokenState = createPersistedState("token");
const usePIDState = createPersistedState("pid");
const useMobileState = createPersistedState("mobile");

const ForgotPasswordPage = () => {
  const history = useHistory();
  const [text, setText] = useState("");
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [_, setToken] = useTokenState();
  const [__, setPID] = usePIDState();
  const [___, setMobile] = useMobileState();
  const [isFetching, setIsFetching] = useState(false);
  const [shouldRegister, setShouldRegister] = useState(false);
  const { t } = useTranslation();

  const handleChange = (e) => {
    setText(e.target.value);
  };

  // TODO: Same as the one in Login Page - Do DRY
  const onRegister = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("pid");
    localStorage.removeItem("Date");
    localStorage.removeItem("i18nextLng");
    localStorage.removeItem("onboardingHist");
    history.push("/register");
  };

  const onSendOTP = async () => {
    setIsFetching(true);
    setShouldRegister(false);
    try {
      const PID = getIC4ID(text);
      const data = await CommonService.getOTP(PID);
      if (data && data.status.code !== 200) {
        setShowError(true);
        setErrorMessage(data.status.message);
        if (data.status.code == 4028) {
          setShouldRegister(true);
        } else {
          setText("");
        }
      } else {
        setShowError(false);
        setErrorMessage("");
        setPID(parsePID(text));
        setToken(data.tid);
        setMobile(data.mobile);
        history.push("/check-sms");
      }
    } catch (e) {
      setShowError(true);
      setErrorMessage("Unable to parse Patient ID");
      setText("");
    }
    setIsFetching(false);
  };

  const RegisterCTA = () => (
    <>
      <div className="btn_block d-flex justify-content-center mb-3 mt-5">
        <button
          className="btn btn_primary"
          disabled={!text || isFetching}
          onClick={onRegister}
        >
          &nbsp;{t("login.REGISTRATION.button2")}
        </button>
      </div>
      <Link
        to="/forgot-password"
        onClick={() => {
          setShowError(false);
          setText("");
          setErrorMessage("");
          setShouldRegister(false);
        }}
        className="link_back mt-5"
        style={{ color: "#0060A6", fontWeight: "700" }}
      >
        Back
      </Link>
    </>
  );

  const DefaultCTA = () => (
    <>
      <div className="btn_block d-flex justify-content-center mb-3 mt-5">
        <button
          className="btn btn_primary"
          disabled={!text || isFetching}
          onClick={onSendOTP}
        >
          {isFetching && (
            <span className="icon ml-4 fa-solid fa-spinner fa-spin"></span>
          )}
          &nbsp;{t("sidenav.MY-PROFILE.send")}
        </button>
      </div>
      <Link
        to="/login"
        className="link_back mt-5"
        style={{ color: "#0060A6", fontWeight: "700" }}
      >
        {t("sidenav.MY-PROFILE.login")}
      </Link>
    </>
  );

  return (
    <>
      <div className="body_content m-0 mt-5 mb-2 p-0 ">
        <div className="pwd_content">
          <div className="thumbnail wow zoomIn">
            <img src={ForgotPwd} alt="" className="img-fluid img_fit" />
          </div>
          <div className="section_title">
            <h4 className="maintitle">
              {t("appointment.FORGET-PASSWORD.message1")}
            </h4>
            <p className="desc text-center">
              {t("appointment.FORGET-PASSWORD.message2")} <br />
              {t("appointment.FORGET-PASSWORD.message22")}
            </p>
          </div>
          <div className="fill_form light_fill_form">
            <div className="field_group">
              <AnimatedTextInput
                label={t("onboard.PID.inputLbl")}
                value={text}
                onChange={handleChange}
                isFocused={true}
              />
              {showError && <p style={{ color: "red" }}>{errorMessage}</p>}
            </div>
            {shouldRegister ? <RegisterCTA /> : <DefaultCTA />}
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPasswordPage;
